import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import { CurrencyFigure } from '../../Figure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'c',
  title: 'Price (USD)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get rightAlign() {
    return true;
  }
}


var DetailColumn = function(props) {
  return (
    <td className="text-right">
      <CurrencyFigure amount={props.row.price} formatter="medium" />
    </td>
  );
}


class Price extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.price < b.price) {
      return -1;
    }
    if (a.price > b.price) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.price < b.price) {
      return 1;
    }
    if (a.price > b.price) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default Price;

